import React from "react";

export const Blog = () => {
  return (
    <div className="blog-area">
      <div className="blog-area-in">
        <div className="blog-single">
          <div className="blog-body">
            <div className="blog-img">
              <img
                src="https://productimages.hepsiburada.net/s/28/375/10234378616882.jpg"
                alt="blog-1"
              />
            </div>
            <div className="blog-title">
              <p>ANTİOKSİDANLAR</p>
            </div>
            <div className="blog-desc">
              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
